import { render } from "./ProfileLearnSubpage.vue?vue&type=template&id=17a029aa&scoped=true"
import script from "./ProfileLearnSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileLearnSubpage.vue?vue&type=script&lang=js"

import "./ProfileLearnSubpage.vue?vue&type=style&index=0&id=17a029aa&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a029aa"]])

export default __exports__